import { useEffect, useRef, useState } from "react";

import { getCaseId, getClientId } from "../../../../Utils/helper";
import { api_without_cancellation } from "../../../../api/api";
import { notifyPageAttachmentsChanged } from "../../../../Utils/pageAttachmentEvents";
import CaseUploadButton from "../../../common/CaseUploadButton";

import PhotoTabComponent from "./components/photo-component";

const PhotoTab = ({ pageId, pageName, onAttachmentsChange }) => {
  const origin = process.env.REACT_APP_BACKEND_URL;

  const currentCaseId = getCaseId();
  const [pageView] = useState("default");

  const activeTab = pageId === "" ? "all" : (pageId ?? "all");
  const [tabData, setTabData] = useState(null);
  const [_tabData, _setTabData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refetchLoading, setrefetchLoading] = useState(false);

  const abortControllerRef = useRef(null);

  const fetchDataFully = async () => {
    if (!refetchLoading) setrefetchLoading(true);

    // Cancel any ongoing request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new AbortController
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      // First API call
      const response = await api_without_cancellation.get(
        `${origin}/api/photo/list-page-photo-optimized/`,
        {
          params: {
            page_id: activeTab,
            case_id: currentCaseId || "",
            client_id: getClientId(),
          },
          signal: controller.signal,
        }
      );

      if (response.status === 200) {
        const data = response.data;
        setTabData(data);
        _setTabData(data);
        notifyPageAttachmentsChanged(
          currentCaseId,
          activeTab === "all" ? null : activeTab,
          "photos"
        );
        onAttachmentsChange?.();
        setLoading(false);
        setrefetchLoading(false);
      }
    } catch (error) {
      if (error.name !== "CanceledError" && error.name !== "AbortError") {
        console.error("Error fetching data:", error);
      }
    } finally {
      // Ensure loading flags are reset in all scenarios
      setLoading(false);
      setrefetchLoading(false);
    }
  };

  useEffect(() => {
    const fetchDataFirstTime = async () => {
      setLoading(true);
      // Set loading to true before making the API call
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Create a new controller
      const controller = new AbortController();
      abortControllerRef.current = controller;
      const response = await api_without_cancellation.get(
        `${origin}/api/photo/list-page-photo-optimized/`,
        {
          params: {
            page_id: activeTab,
            case_id: currentCaseId ? currentCaseId : "",
            client_id: getClientId(),
          },
          signal: controller.signal,
        }
      );
      if (response.status === 200) {
        setTabData(response.data);
        _setTabData(response.data);
        notifyPageAttachmentsChanged(
          currentCaseId,
          activeTab === "all" ? null : activeTab,
          "photos"
        );
        onAttachmentsChange?.();
        setLoading(false);
      }
    };

    fetchDataFirstTime();
  }, [activeTab, currentCaseId, origin, onAttachmentsChange]);

  return (
    <>
      {
        <div
          className="d-flex align-items-center justify-content-center height-25 m-b-5"
          style={{
            background: "var(--primary)",
            color: "white",
            fontSize: "14px",
            fontWeight: "600",
            textTransform: "uppercase",
            position: "relative",
          }}
        >
          <span>{pageName} Photos</span>
          <div style={{ position: "absolute", top: 0, right: 9, height: 25 }}>
            <CaseUploadButton
              pageId={activeTab === "all" ? null : activeTab}
              pageName={pageName}
              onUploaded={fetchDataFully}
            />
          </div>
        </div>
      }
      <PhotoTabComponent
        data={
          activeTab === "all"
            ? tabData?.data || []
            : [
                {
                  page_docs: tabData?.data,
                  panels: tabData?.panels,
                  page: tabData?.page,
                  page_slots: tabData?.page_slots,
                },
              ]
        }
        // data={tabData?.data || []}
        currentPageId={activeTab === "all" ? null : activeTab}
        loading={loading}
        refetchData={fetchDataFully}
        refetchLoading={refetchLoading}
        pageView={pageView}
        tabData={
          activeTab === "all"
            ? tabData?.data || []
            : [
                {
                  page_docs: tabData?.data,
                  panels: tabData?.panels,
                  page: tabData?.page,
                  page_slots: tabData?.page_slots,
                },
              ]
        }
        activeTab={activeTab}
      />
    </>
  );
};

export default PhotoTab;
